/*
 * @Author: Robin
 * @Date: 2021-03-05 16:11:41
 * @LastEditors: Robin
 * @LastEditTime: 2021-03-05 17:07:11
 * @Description: 表单相关接口
 */
import request from '@/utils/request';

/**
 * 提交表单数据
 * @param {int} fid
 * @param {object} attrs
 * @param {int} qr_id
 */
export function add(fid, attrs, qr_id) {
    // 组装数据
    let data = new FormData();
    data.append('fid', fid);
    data.append('attrs', JSON.stringify(attrs));
    data.append('qr_id', qr_id);
    return request({
        url: '/form/add_record',
        method: 'post',
        data,
    });
}

/**
 * 获取表单记录
 * @param {int} qr_id
 * @param {int} fid
 */
export function getRecords(qr_id, fid) {
    return request({
        url: '/form/records',
        method: 'get',
        params: { qr_id, fid },
    });
}
